/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import PropTypes from "prop-types";
import { withTranslation } from 'react-i18next';
import Preloader from '../layout/Preloader';
import paquetesClient from '../../api/paquetes';
import PaqueteCheckoutContenido from './paquetes-checkout-contenido';
import Commons from '../../commons/commons';
import ErrorCarga from '../layout/error-paquete/error-paquete';
import { savePackageDetails } from '../../redux/actions/packages-actions';

class PaqueteCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paquete: {},
      preloader: true,
      habitaciones: [],
      cantidadPasajeros: 0,
      cupos: 0,
      error: false,
      errorMensaje: '',
    };
    this.obtenerDatoUrl = this.obtenerDatoUrl.bind(this);
    this.getPaquete = this.getPaquete.bind(this);
    this.armarDatos = this.armarDatos.bind(this);
    this.setearPreloader = this.setearPreloader.bind(this);
    this.setearError = this.setearError.bind(this);
    this.getInitialParams = this.getInitialParams.bind(this);
  }

  componentDidMount() {
    this.getInitialParams(() => {
      this.getPaquete();
    });
  }

  getInitialParams(callback) {
    const distribucion = Commons.obtenerDistribucion();
    const cantidadPasajeros = Commons.obtenerCantidadPasajeros(distribucion);
    this.setState({
      cantidadPasajeros,
      habitaciones: distribucion,
      cupos: cantidadPasajeros,
    }, callback);
  }

  getPaquete() {
    const params = this.armarDatos();
    const { cantidadPasajeros } = this.state;
    paquetesClient
      .obtenerDetalle(params)
      .then((res) => {
        if (res && res.data.disponible) {
          this.props.actions.savePackageDetails({
            isReady: true,
            paxQuantity: cantidadPasajeros,
            data: res.data,
          });
          this.setState({
            paquete: res.data,
            preloader: false,
            error: false,
          });
        } else {
          this.setState({ error: true, preloader: false, errorMensaje: 'obtenerDetalle else' });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: true, preloader: false });
      });
  }

  obtenerDatoUrl(query) {
    return new URLSearchParams(isClient ? window.location.search : '').get(query);
  }

  armarDatos() {
    return {
      idProveedor: this.obtenerDatoUrl('p'),
      IdSalida: this.obtenerDatoUrl('t'),
      fechaSalida: this.obtenerDatoUrl('s'),
      distribucion: this.obtenerDatoUrl('h'),
      idProducto: this.obtenerDatoUrl('i'),
      idDestino: this.obtenerDatoUrl('d'),
      nroGrupo: this.obtenerDatoUrl('ngrupo'),
      TipoMoneda: 'ARS',
    };
  }

  setearPreloader() {
    this.setState({
      preloader: true,
    });
  }

  setearError(errorMensaje = '') {
    debugger;
    this.setState({
      error: true,
      errorMensaje,
    });
  }

  render() {
    const { t } = this.props;
    const { preloader, error, paquete } = this.state;

    if (preloader && !error) {
      return <Preloader titulo={t('checkout.preloaderText')} />;
    }
    if (error) {
      return <ErrorCarga mensaje={this.state.errorMensaje} />;
    }
    return (
      <PaqueteCheckoutContenido
        cupos={this.state.cupos}
        setearPreloader={this.setearPreloader}
        setearError={this.setearError}
        habitaciones={this.state.habitaciones}
        paquete={paquete}
        cantidadPasajeros={this.state.cantidadPasajeros}
      />
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    actions: bindActionCreators({ savePackageDetails }, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(withTranslation(['translations'])(PaqueteCheckout));
